import Component from '@glimmer/component';
import { get } from '@ember/object';

export default class extends Component {
  get flowCount() {
    const { locationObj } = this.args;
    return get(this.args, `meta.total-count.location-id.${locationObj.id}`);
  }
}
